// extracted by mini-css-extract-plugin
export default {"wrapper":"section_wrapper__qDV8L","title":"section_title__Vn7xD","sticky":"section_sticky__yLmq1"};